'use client'

import { cn } from '@mntn-dev/ui-utilities'
import type { PropsWithChildren } from 'react'
import { useDataListContext } from './use-data-list.ts'

type DataListTitleProps = PropsWithChildren

const DataListTitle = ({ children }: DataListTitleProps) => {
  const { fontSizeClassName, titleColorClassName } = useDataListContext()

  return (
    <dt
      className={cn(
        'leading-normal whitespace-nowrap overflow-hidden text-ellipsis',
        fontSizeClassName,
        titleColorClassName
      )}
    >
      {children}
    </dt>
  )
}

export { DataListTitle }
